export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const UPDATE_ACCESS_TOKEN = "UPDATE_ACCESS_TOKEN";
export const UPDATE_IS_REFRESHING_TOKEN = "UPDATE_IS_REFRESHING_TOKEN";

export const ALERTS_CLEAR = "ALERTS_CLEAR";
export const ALERTS_SUCCESS = "ALERTS_SUCCESS";
export const ALERTS_ERROR = "ALERTS_ERROR";
export const ALERTS_WARNING = "ALERTS_WARNING";
export const ALERTS_INFO = "ALERTS_INFO";

export const UPDATE_COUNTRY_IS_FETCHING = "UPDATE_COUNTRY_IS_FETCHING";
export const UPDATE_COUNTRY_LIST = "UPDATE_COUNTRY_LIST";
export const UPDATE_CATEGORY_IS_FETCHING = "UPDATE_CATEGORY_IS_FETCHING";
export const UPDATE_CATEGORY_LIST = "UPDATE_CATEGORY_LIST";
export const UPDATE_PERMISSIONS_LIST = "UPDATE_PERMISSIONS_LIST";
export const UPDATE_PERMISSIONS_IS_FETCHING = "UPDATE_PERMISSIONS_IS_FETCHING";
